// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__ZlxM9","icon":"style_icon__UEbLx","title":"style_title__2xfNn"};